// @system — the brand logo image element with intrinsic dimensions.
// `width`/`height` attributes let the browser reserve the box before the file loads (no layout
// shift, CLS) — the responsive gate (e2e/@system/10-responsive.spec.js) requires every image
// to be dimensioned. Decorative by default (alt="") because the adjacent text carries the name.
import { cn } from '@/app/lib/@system/utils'

/**
 * @param {object} props
 * @param {string} props.src - Logo URL (usually `info.logo` / `info.logoDark`)
 * @param {number} [props.size=32] - Rendered square size in CSS px (also the intrinsic width/height)
 * @param {string} [props.alt=""] - Alternative text; leave empty when the brand name is next to it
 * @param {string} [props.className]
 */
export function BrandMark({ src, size = 32, alt = '', className, ...props }) {
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      decoding="async"
      className={cn('shrink-0 object-contain', className)}
      {...props}
    />
  )
}
